import { t } from 'services/localization';
import { ApiAmaxPayLegalEntityType } from 'shared/data/webApp/v2';

import { messages as countryNames } from '../countryNames';
import { FieldItem } from './paymentDetails.types';

export const paymentDetailsFields: FieldItem[] = [
    {
        title: t('bank_account_country'),
        path: 'bankAccountDetails.bankAccount.countryIsoCode',
        getDisplayValue: (value) => {
            return countryNames[value as keyof typeof countryNames] || value;
        },
    },
    {
        title: t('account_currency'),
        path: 'bankAccountDetails.bankAccount.currencyIsoCode',
    },
    {
        title: t('payment_method'),
        path: 'payNetworkName',
    },
    {
        title: t('entity_type'),
        path: 'bankAccountDetails.legalEntity.legalEntityType',
        getDisplayValue: (value) => {
            switch (value) {
                case ApiAmaxPayLegalEntityType.company:
                    return t('company_name');
                case ApiAmaxPayLegalEntityType.individual:
                    return t('individual');
                default:
                    return value;
            }
        },
    },
    {
        title: t('account_name'),
        path: 'bankAccountDetails.bankAccount.bankAccountName',
    },
    {
        title: t('account_number'),
        path: 'bankAccountDetails.bankAccount.routing.bankAccountNumber',
    },
    {
        title: t('bic_swift_code'),
        path: 'bankAccountDetails.bankAccount.routing.bicSwift',
    },
    {
        title: t('iban'),
        path: 'bankAccountDetails.bankAccount.routing.iban',
    },
    {
        title: t('address'),
        path: 'bankAccountDetails.legalEntity.addressInfo.address',
    },
    {
        title: t('city'),
        path: 'bankAccountDetails.legalEntity.addressInfo.city',
    },
    {
        title: t('country'),
        path: 'bankAccountDetails.payerBankCountry',
        getDisplayValue: (value) => {
            return countryNames[value as keyof typeof countryNames] || value;
        },
    },
    {
        title: t('postal_code'),
        path: 'bankAccountDetails.legalEntity.addressInfo.postalCode',
    },
    {
        title: t('state_province'),
        path: 'bankAccountDetails.legalEntity.addressInfo.region',
    },
    {
        title: t('company_name'),
        path: 'bankAccountDetails.legalEntity.companyName',
    },
    {
        title: t('first_name'),
        path: 'bankAccountDetails.legalEntity.firstName',
    },
    {
        title: t('last_name'),
        path: 'bankAccountDetails.legalEntity.lastName',
    },
    {
        title: t('sort_code'),
        path: 'bankAccountDetails.bankAccount.routing.sortCode',
    },
    {
        title: t('aba'),
        path: 'bankAccountDetails.bankAccount.routing.aba',
    },
    {
        title: t('bsb'),
        path: 'bankAccountDetails.bankAccount.routing.bsb',
    },
    {
        title: t('institution_number'),
        path: 'bankAccountDetails.bankAccount.routing.institutionNumber',
    },
    {
        title: t('incorporation_number'),
        path: 'bankAccountDetails.bankAccount.routing.incorporationNumber',
    },
    {
        title: t('bank_code'),
        path: 'bankAccountDetails.bankAccount.routing.bankCode',
    },
    {
        title: t('branch_code'),
        path: 'bankAccountDetails.bankAccount.routing.branchCode',
    },
    {
        title: t('clabe'),
        path: 'bankAccountDetails.bankAccount.routing.clabe',
    },
    {
        title: t('cnaps'),
        path: 'bankAccountDetails.bankAccount.routing.cnaps',
    },
    {
        title: t('ifsc_code'),
        path: 'bankAccountDetails.bankAccount.routing.ifsc',
    },
];
